import React, { useState, useEffect } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { SigningFontModal, Font } from './SigningFontModal';

//const brokerClientApi = new BrokerClientApi();

export interface EsignModalProps {
    isOpen: boolean;
    confirmCallback?: (fontname: Font | undefined) => void;
    cancelCallback?: () => void;
    signatureText?: string;
    agreementHtml?: string;
    ipAddress?: string;
    rejectLabel?: string;
    acceptLabel?: string;
    font?: Font;
}

export const EsignModal: React.FC<EsignModalProps> = ({
    isOpen,
    confirmCallback,
    cancelCallback,
    signatureText,
    agreementHtml,
    ipAddress,
    rejectLabel = 'REJECT',
    acceptLabel = 'ACCEPT',
    font = undefined,
}) => {
    const [openSigningFontModal, setOpenSigningFontModal] = useState(false);
    const [agreeDisabled, setAgreeDisabled] = useState(true);
    const [signatureFont, setSignatureFont] = useState<Font | undefined>(font);
    const [readAgreemnent, set_readAgreemnent] = React.useState(true);
    const [acceptClicked, set_acceptClicked] = useState(false);
    const dialogRef = React.useCallback((dialog) => {
        // if (!dialog) return;
        // const height = dialog.scrollHeight;
        // const offsetHeigt = dialog.offsetHeight + 50;
        // const isBottom = height - offsetHeigt <= dialog.scrollTop;
        set_readAgreemnent(true);
    }, []);

    useEffect(() => {
        window.addEventListener('resize', scrollToTheBottom);
    });

    const handleConfirm = () => {
        set_acceptClicked(true);
        confirmCallback && confirmCallback(signatureFont);
    };
    const handleCancel = () => {
        cancelCallback && cancelCallback();
    };

    const onClickToSign = (event) => {
        event.preventDefault();

        if (signatureFont) {
            handleSigningConfirm(signatureFont);
        } else {
            setOpenSigningFontModal(true);
        }
    };

    const handleSigningConfirm = (font) => {
        if (!font) return;
        /* istanbul ignore else */
        if (font) setAgreeDisabled(false);

        setSignatureFont(font);
        setOpenSigningFontModal(false);
    };

    const handleSigningCancel = () => {
        setOpenSigningFontModal(false);
    };

    const styles: Record<string, React.CSSProperties> = {
        flexboxContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        signatureContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        buttonDiv: {
            paddingTop: 20,
            paddingRight: 10,
            paddingBottom: 0,
            paddingLeft: 10,
        },
        button: {
            width: 175,
        },
        signButton: {
            margin: 0,
        },
        noPadding: {
            padding: 0,
        },
    };

    const scrollToTheBottom = (e) => {
        // if (!isOpen) return;
        // const element = document.getElementById('alert-dialog-content');
        // if (!element) return;
        // const height = element.scrollHeight;
        // const offsetHeigt = element.offsetHeight + 30;
        // const isBottom = height - offsetHeigt <= element.scrollTop;
        set_readAgreemnent(true);
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='lg'
                style={{ zIndex: 2100 }}
            >
                <DialogContent
                    id='alert-dialog-content'
                    onScroll={scrollToTheBottom}
                    ref={dialogRef}
                >
                    <DialogContentText
                        id='alert-dialog-description'
                        className='eSignModal'
                        dangerouslySetInnerHTML={{ __html: agreementHtml }}
                    ></DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className='modal-content modal-content--esign'>
                        <div className='modal-body'>
                            <div
                                className='standard-form'
                                style={styles.noPadding}
                            >
                                <div style={styles.flexboxContainer}>
                                    <div style={styles.signatureContainer}>
                                        <div>
                                            <label>
                                                <strong>Signed by:</strong>
                                            </label>
                                        </div>
                                        <div
                                            style={{
                                                marginTop: 10,
                                                marginBottom: 10,
                                            }}
                                        >
                                            {signatureFont ? (
                                                <div
                                                    style={{
                                                        fontSize: 24,
                                                        fontFamily: signatureFont.name,
                                                    }}
                                                >
                                                    {signatureText}
                                                </div>
                                            ) : (
                                                <button
                                                    type='button'
                                                    className='button hollow'
                                                    style={styles.signButton}
                                                    onClick={onClickToSign}
                                                >
                                                    Click to Sign
                                                </button>
                                            )}
                                        </div>
                                        <div>
                                            <label>
                                                <strong>{signatureText}</strong>
                                            </label>
                                        </div>
                                        <div>
                                            <label>IP Address: {!ipAddress ? 'unknown' : ipAddress}</label>
                                        </div>
                                    </div>
                                </div>
                                {/* <div
                                    style={{
                                        minHeight: '24px',
                                    }}
                                >
                                    {!readAgreemnent && (
                                        <div style={styles.flexboxContainer}>
                                            <span
                                                className='text'
                                                style={{
                                                    fontStyle: 'italic',
                                                    fontWeight: 'bold',
                                                    fontSize: 'small',
                                                    lineHeight: '12px',
                                                }}
                                            >
                                                Please read the agreement in full and <br />
                                                scroll to the bottom to continue
                                            </span>
                                        </div>
                                    )}
                                </div> */}
                                <div className='modal-content-actions'>
                                    <button
                                        type='button'
                                        data-testid='do-not-accept-button'
                                        className='button redButton'
                                        style={styles.button}
                                        onClick={handleCancel}
                                    >
                                        {rejectLabel}
                                    </button>
                                    <button
                                        type='button'
                                        data-testid='accept-button'
                                        className='button primary'
                                        style={styles.button}
                                        onClick={handleConfirm}
                                        disabled={acceptClicked || !(agreeDisabled === !readAgreemnent)}
                                    >
                                        {acceptLabel}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
            <SigningFontModal
                isOpen={openSigningFontModal}
                signatureText={signatureText}
                confirmCallback={handleSigningConfirm}
                cancelCallback={handleSigningCancel}
                defaultSignature={true}
            />
        </div>
    );
};
